import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { RiCloseLine } from 'react-icons/ri';
import axios from 'axios';
// import './MedicalStoreModal.css';

const MedicalStoreModal = ({ store, isEditing, onClose, onSave }) => {
    const [formData, setFormData] = useState({
        name: store?.name || '',
        dlNumber: store?.dlNumber || '',
        gstNumber: store?.gstNumber || '',
        address: store?.address || '',
        mobile: store?.mobile || '',
        storeImage: null,
        mapIframe: store?.mapIframe || ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [imagePreview, setImagePreview] = useState(store?.storeImage || null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({
                ...prev,
                storeImage: file
            }));
            // Create preview URL
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('name', formData.name.trim());
            formDataToSend.append('dlNumber', formData.dlNumber.trim());
            formDataToSend.append('gstNumber', formData.gstNumber.trim());
            formDataToSend.append('address', formData.address.trim());
            formDataToSend.append('mobile', formData.mobile.trim());
            formDataToSend.append('mapIframe', formData.mapIframe.trim());
            if (formData.storeImage) {
                formDataToSend.append('image', formData.storeImage);
            }

            const url = isEditing
                ? `https://api.swasthmitra.com/api/stores/${store._id}`
                : 'https://api.swasthmitra.com/api/stores/add';

            const response = await axios({
                method: isEditing ? 'patch' : 'post',
                url: url,
                data: formDataToSend,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.success) {
                onSave();
            } else {
                throw new Error(response.data.message);
            }
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'Error saving store');
        } finally {
            setLoading(false);
        }
    };

    return (
        <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <motion.div
                className="modal-content"
                initial={{ scale: 0.5, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.5, opacity: 0 }}
            >
                <button className="close-btn" onClick={onClose}>
                    <RiCloseLine />
                </button>

                <div className="modal-header">
                    <h2>{isEditing ? 'Edit Medical Store' : 'Add Medical Store'}</h2>
                </div>

                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Store Name*</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Drug License Number*</label>
                        <input
                            type="text"
                            name="dlNumber"
                            value={formData.dlNumber}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>GST Number*</label>
                        <input
                            type="text"
                            name="gstNumber"
                            value={formData.gstNumber}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Address*</label>
                        <textarea
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            required
                            rows="3"
                        />
                    </div>

                    <div className="form-group">
                        <label>Google Maps Embed URL*</label>
                        <textarea
                            name="mapIframe"
                            value={formData.mapIframe}
                            onChange={handleChange}
                            placeholder="Paste Google Maps iframe code here"
                            rows="3"
                        />
                    </div>

                    <div className="form-group">
                        <label>Mobile Number*</label>
                        <input
                            type="tel"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Store Image</label>
                        <input
                            type="file"
                            name="storeImage"
                            onChange={handleImageChange}
                            accept="image/*"
                        />
                        {imagePreview && (
                            <div className="image-preview">
                                <img src={imagePreview} alt="Store preview" />
                            </div>
                        )}
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="cancel-btn" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="save-btn" disabled={loading}>
                            {loading ? 'Saving...' : 'Save Store'}
                        </button>
                    </div>
                </form>
            </motion.div>
        </motion.div>
    );
};

export default MedicalStoreModal; 